import { createHash } from "crypto";

export function gravatar(email) {
  const digest = createHash("md5").update(email).digest("hex");
  const url = new URL(digest, "https://www.gravatar.com/avatar/");
  return url.href;
}
